import styled, { css } from 'styled-components'

export const NavButton = styled.button<{ $active: boolean }>`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  border: none;
  color: ${(props) => (props.theme.name === 'light' ? '#001f5c' : '#ffffff')};
  font-size: 24px;
  height: 100%;
  background: ${(props) => (props.theme.name === 'light' ? '#ffffff' : 'rgba(255, 255, 255, 0.08)')};
  backdrop-filter: blur(10px);
  padding: 16px 24px;
  border-radius: 16px;
  border: 1px solid ${(props) => (props.theme.name === 'light' ? '#cbd5e1' : 'rgba(255, 255, 255, 0.05)')};
  box-shadow: ${(props) => (props.theme.name === 'light' ? '0 4px 12px rgba(0, 31, 92, 0.08)' : 'none')};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    border-color: #a6c10b;
  }

  ${({ $active }) =>
    $active &&
    css`
      background: #a6c10b !important;
      color: #001f5c !important;
      border-color: #a6c10b !important;
      box-shadow: 0 4px 14px rgba(166, 193, 11, 0.35) !important;
    `}
`
